var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5088 21.5C24.3599 21.5 27.0942 20.3674 29.1102 18.3514C31.1262 16.3354 32.2588 13.6011 32.2588 10.75C32.2588 7.89892 31.1262 5.16462 29.1102 3.1486C27.0942 1.13259 24.3599 0 21.5088 0C18.6577 0 15.9234 1.13259 13.9074 3.1486C11.8914 5.16462 10.7588 7.89892 10.7588 10.75C10.7588 13.6011 11.8914 16.3354 13.9074 18.3514C15.9234 20.3674 18.6577 21.5 21.5088 21.5ZM28.6755 10.75C28.6755 12.6507 27.9204 14.4736 26.5764 15.8176C25.2324 17.1616 23.4095 17.9167 21.5088 17.9167C19.6081 17.9167 17.7852 17.1616 16.4412 15.8176C15.0972 14.4736 14.3421 12.6507 14.3421 10.75C14.3421 8.84928 15.0972 7.02641 16.4412 5.6824C17.7852 4.33839 19.6081 3.58333 21.5088 3.58333C23.4095 3.58333 25.2324 4.33839 26.5764 5.6824C27.9204 7.02641 28.6755 8.84928 28.6755 10.75ZM43.0088 39.4167C43.0088 43 39.4255 43 39.4255 43H3.59212C3.59212 43 0.00878906 43 0.00878906 39.4167C0.00878906 35.8333 3.59212 25.0833 21.5088 25.0833C39.4255 25.0833 43.0088 35.8333 43.0088 39.4167ZM39.4255 39.4023C39.4219 38.5208 38.8736 35.8692 36.4441 33.4397C34.1078 31.1033 29.711 28.6667 21.5088 28.6667C13.3065 28.6667 8.90979 31.1033 6.57346 33.4397C4.14396 35.8692 3.59929 38.5208 3.59212 39.4023H39.4255Z",
    fill: "#009476"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white",
    transform: "translate(0.00878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.01de49ae7780a12fa4c5cdfd05b31d9b.svg";
export { ForwardRef as ReactComponent };